import { Languages } from "lucide-react";
import { useT, type Locale } from "@/i18n";
import { cn } from "@/lib/cn";

export function LanguageSwitcher({ compact }: { compact?: boolean }) {
  const { locale, setLocale } = useT();
  const opts: { code: Locale; label: string }[] = [
    { code: "es", label: "ES" },
    { code: "en", label: "EN" },
  ];

  if (compact) {
    return (
      <div className="inline-flex items-center gap-1 rounded-full bg-slate-100 p-1">
        {opts.map((o) => (
          <button
            key={o.code}
            type="button"
            onClick={() => setLocale(o.code)}
            className={cn(
              "h-7 rounded-full px-2.5 text-xs font-semibold transition",
              locale === o.code ? "bg-white text-brand-700 shadow-soft" : "text-slate-500 hover:text-slate-700"
            )}
            aria-pressed={locale === o.code}
          >
            {o.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white p-1 pl-3 shadow-soft">
      <Languages className="h-4 w-4 text-slate-500" />
      {opts.map((o) => (
        <button
          key={o.code}
          type="button"
          onClick={() => setLocale(o.code)}
          className={cn(
            "h-7 rounded-full px-3 text-xs font-semibold transition",
            locale === o.code ? "bg-brand-600 text-white" : "text-slate-500 hover:text-slate-700"
          )}
          aria-pressed={locale === o.code}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
